"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var layout_1 = __importDefault(require("antd/es/layout"));
var palette_1 = require("../theme/palette");
var LinkCSS_1 = require("./LinkCSS");
var VarnishContext_1 = require("./VarnishContext");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBackgroundColor = function (bgcolor, contrast) {
            if (bgcolor) {
                return bgcolor;
            }
            return contrast ? palette_1.palette.background.dark : palette_1.palette.common.white;
        };
        return _this;
    }
    Footer.prototype.render = function () {
        var _this = this;
        var contrast = this.props.variant === 'dark';
        var bgcolor = this.getBackgroundColor(this.props.backgroundColor, contrast);
        return (React.createElement(VarnishContext_1.VarnishContext.Consumer, null, function (_a) {
            var layout = _a.layout;
            return (React.createElement(StyledFooter, { contrast: contrast, layout: layout, bgcolor: bgcolor, className: _this.props.className },
                _this.props.setPageBackground ? (React.createElement(WithPageBackground, { bgcolor: bgcolor })) : null,
                _this.props.children ? (_this.props.children) : (React.createElement("span", null,
                    React.createElement("a", { href: "https://allenai.org" }, "\u00A9 The Allen Institute for Artificial Intelligence"),
                    ' ',
                    "- All Rights Reserved |",
                    ' ',
                    React.createElement("a", { href: "https://allenai.org/privacy-policy.html" }, "Privacy Policy"),
                    ' ',
                    "| ",
                    React.createElement("a", { href: "https://allenai.org/terms.html" }, "Terms of Use")))));
        }));
    };
    Footer.defaultProps = {
        setPageBackground: true,
    };
    return Footer;
}(React.PureComponent));
exports.Footer = Footer;
var WithPageBackground = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    html, body {\n        background: ", ";\n    }\n"], ["\n    html, body {\n        background: ", ";\n    }\n"])), function (_a) {
    var bgcolor = _a.bgcolor;
    return bgcolor.hex;
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var StyledFooter = (0, styled_components_1.default)(function (_a) {
    var contrast = _a.contrast, rest = __rest(_a, ["contrast"]);
    return React.createElement(layout_1.default.Footer, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    && {\n        background: ", ";\n        color: ", ";\n        text-align: ", ";\n        a[href] {\n            ", ";\n        }\n    }\n"], ["\n    && {\n        background: ", ";\n        color: ", ";\n        text-align: ", ";\n        a[href] {\n            ", ";\n        }\n    }\n"])), function (_a) {
    var bgcolor = _a.bgcolor;
    return bgcolor.hex;
}, function (_a) {
    var theme = _a.theme, contrast = _a.contrast;
    return contrast
        ? theme.palette.text.contrast.toString()
        : theme.palette.text.primary.toString();
}, function (_a) {
    var layout = _a.layout;
    return (layout !== 'left-aligned' ? 'center' : null);
}, function (_a) {
    var contrast = _a.contrast;
    return (contrast ? LinkCSS_1.LinkCSS.contrast() : null);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Footer.js.map